import {useTranslation} from "react-i18next";

const RentProperty = () => {

    const { t } = useTranslation();

    return (
        <>
            <div>
                <h4>{t('serviceDetailPage.affitti-locazioni.contentTitle1')}</h4>
                <p dangerouslySetInnerHTML={{ __html: t('serviceDetailPage.affitti-locazioni.contentText1') as string}}></p>
                <p dangerouslySetInnerHTML={{ __html: t('serviceDetailPage.affitti-locazioni.contentText2') as string}}></p>
                <p dangerouslySetInnerHTML={{ __html: t('serviceDetailPage.affitti-locazioni.contentText3') as string}}></p>
            </div>
            <div>
                <h4>{t('serviceDetailPage.affitti-locazioni.contentTitle2')}</h4>
                <p dangerouslySetInnerHTML={{ __html: t('serviceDetailPage.affitti-locazioni.contentText4') as string}}></p>
                <p dangerouslySetInnerHTML={{ __html: t('serviceDetailPage.affitti-locazioni.contentText5') as string}}></p>
                <p dangerouslySetInnerHTML={{ __html: t('serviceDetailPage.affitti-locazioni.contentText6') as string}}></p>
                <p dangerouslySetInnerHTML={{ __html: t('serviceDetailPage.affitti-locazioni.contentText7') as string}}></p>
                <ul>
                    <li>{t('serviceDetailPage.affitti-locazioni.listItem1')}</li>
                    <li>{t('serviceDetailPage.affitti-locazioni.listItem2')}</li>
                    <li>{t('serviceDetailPage.affitti-locazioni.listItem3')}</li>
                    <li>{t('serviceDetailPage.affitti-locazioni.listItem4')}</li>
                    <li>{t('serviceDetailPage.affitti-locazioni.listItem5')}</li>
                    <li>{t('serviceDetailPage.affitti-locazioni.listItem6')}</li>
                    <li>{t('serviceDetailPage.affitti-locazioni.listItem7')}</li>
                    <li>{t('serviceDetailPage.affitti-locazioni.listItem8')}</li>
                </ul>
                <p dangerouslySetInnerHTML={{ __html: t('serviceDetailPage.affitti-locazioni.contentText8') as string}}></p>
            </div>
            <div>
                <h4>{t('serviceDetailPage.affitti-locazioni.contentTitle3')}</h4>
                <p dangerouslySetInnerHTML={{ __html: t('serviceDetailPage.affitti-locazioni.contentText9') as string}}></p>
                <p dangerouslySetInnerHTML={{ __html: t('serviceDetailPage.affitti-locazioni.contentText10') as string}}></p>
                <p dangerouslySetInnerHTML={{ __html: t('serviceDetailPage.affitti-locazioni.contentText11') as string}}></p>
                <p dangerouslySetInnerHTML={{ __html: t('serviceDetailPage.affitti-locazioni.contentText12') as string}}></p>
                <p dangerouslySetInnerHTML={{ __html: t('serviceDetailPage.affitti-locazioni.contentText13') as string}}></p>
                <p dangerouslySetInnerHTML={{ __html: t('serviceDetailPage.affitti-locazioni.contentText14') as string}}></p>
            </div>
        </>
    )
}

export default RentProperty;